import { USER_SESSION_KEY } from "@/constants/auth.constants";
import { UserSchema } from "@/schemas/user.schema";
import { z } from "zod";

export const setTokenData = (token: string, user: z.infer<typeof UserSchema>) => {
    sessionStorage.setItem(USER_SESSION_KEY, JSON.stringify({ token, user }));
}

export const getTokenData = () => {
    const stored = sessionStorage.getItem(USER_SESSION_KEY);
    if (stored) {
        try {
            const parsed = JSON.parse(stored);
            if (parsed && parsed.user) {
                return parsed;
            } else {
                return null;
            }
        } catch {
            return null;
        }
    } else {
        return null;
    }
}

export const removeTokenData = () => {
    sessionStorage.removeItem(USER_SESSION_KEY);
}

export const getToken = () => {
    const stored = sessionStorage.getItem(USER_SESSION_KEY);
    if (stored) {
        try {
            const parsed = JSON.parse(stored);
            if (parsed && parsed.token) {
                return parsed.token;
            } else {
                return null;
            }
        } catch {
            return null;
        }
    } else {
        return null;
    }
}